import React, { useEffect } from 'react'

import './styles.css'
import { Link } from 'react-router-dom';
import AnimatedSVG from '../Loader';
import { Tooltip } from 'antd';

function PromptSuggestions({ className, suggestion = "Some commonly used prompts", promptData = [], isLoadingPrompt = false, sendPromtApi }) {
  const containerRef = React.useRef(null);
  const promptDescRef = React.useRef(null);
  const [selectedPrompt, setSelectedPrompt] = React.useState(null);

  useEffect(() => {
    setSelectedPrompt(promptData[0]);
  }, [promptData]);

  const handleMouseOver = (index) => {
    setSelectedPrompt(promptData[index]);
  };

  // React.useLayoutEffect(() => () => {
  //   const badgePills = containerRef.current?.querySelectorAll('.badge-pill') || null;
  //   if (!badgePills) return null;

  //   const tl = gsap.timeline();

  //   tl
  //     .fromTo(
  //       badgePills,
  //       { opacity: 0, x: -20 }, // Initial state
  //       {
  //         opacity: 1,
  //         x: 0,
  //         stagger: 0.2, // Stagger delay between items
  //         duration: 0.5,
  //         ease: 'power1.out',
  //       }
  //     );

  //   return () => {
  //     tl.kill();
  //   };

  // }, [promptData]);

  // React.useLayoutEffect(() => {
  //   if (!selectedPrompt) return;

  //   const tl = gsap.fromTo(
  //     promptDescRef.current,
  //     { opacity: 0, y: 20 },
  //     {
  //       opacity: 1,
  //       y: 0,
  //       duration: 0.5,
  //       ease: 'power1.out',
  //     }
  //   );

  //   return () => {
  //     tl.kill();
  //   };

  // }, [selectedPrompt]);

  return (
    <div className=''>
      <div className='flex flex-row'>
        <div className='basis-[21%]' />
        {isLoadingPrompt ? <AnimatedSVG className={""} /> :
          <>
            <div className={`space-y-2 ${className} basis-[75%] xl:basis-[65%] pr-2`}>
              {suggestion && <p className='text-text-600 text-sm'>{suggestion}</p>}
              <div className='grid grid-cols-1 lg:grid-cols-2'>
                {promptData.map((item, index) => {
                  const isActive = selectedPrompt?.suggestion === item.suggestion;
                  return (
                    <div
                      className={`mt-3 badge-pill flex flex-row items-center justify-between w-fit gap-1.5 cursor-pointer ${isActive ? 'border-primary-500 bg-[#26BF77] ' : 'text-[#414651] bg-gray-100'}`}
                      key={index}
                      onMouseOver={() => handleMouseOver(index)}
                      onClick={() => { sendPromtApi(item.suggestion) }}
                    >
                      <Tooltip
                        className='w-full'
                        rootClassName={'min-w-[400px]'}
                        placement='bottom'
                        title={
                          <Link className='prompt-desc '>
                            {selectedPrompt && <div dangerouslySetInnerHTML={{ __html: selectedPrompt.explanation }} />}
                          </Link>
                        }>
                        <p className={`${isActive ? 'text-white' : ''}`}>{item.suggestion}</p>
                      </Tooltip>
                    </div>
                  );
                })}

              </div>
            </div>
          </>}
      </div>
    </div>
  );
}



export default PromptSuggestions;